/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Created_WarningInputs */

const en_settings_apikeys_created_warning = /** @type {(inputs: Settings_Apikeys_Created_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy your key now — it won't be shown again.`)
};

const zh_settings_apikeys_created_warning = /** @type {(inputs: Settings_Apikeys_Created_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请立即复制你的密钥，关闭后将无法再次查看。`)
};

/**
* | output |
* | --- |
* | "Copy your key now — it won't be shown again." |
*
* @param {Settings_Apikeys_Created_WarningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_created_warning = /** @type {((inputs?: Settings_Apikeys_Created_WarningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Created_WarningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_created_warning(inputs)
	return zh_settings_apikeys_created_warning(inputs)
});
export { settings_apikeys_created_warning as "settings.apikeys.created_warning" }